import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage } from 'services/apiError'
import PasswordInput from 'components/Inputs/PasswordInput'
import { ReactComponent as ButtonLoading } from 'icons/loading.svg'
import CutileiLogo from 'icons/companies-logo.png'
import { Formik } from 'formik'
import * as Yup from 'yup'

import {
  Container,
  Form,
  Image,
  Title,
  LinkText,
  Label,
  Input,
  ButtonContainer,
  Button,
  LinkButton,
  WarningText,
  ErrorContainer
} from './styles'

export default function CompanySignIn () {
  const [errorMessage, setErrorMessage] = useState (null)
  const navigate = useNavigate ()

  const signInValidation = Yup.object ({
    email: Yup
      .string ()
      .required ('É necessário fornecer um e-mail')
      .email ('Insira um email válido'),
  
    password: Yup
      .string ()
      .required ('É necessário fornecer uma senha')
      .min (8, 'A senha deve conter no minimo 8 caracteres')
  })

  return (
    <Container>
      <Formik
        validationSchema={signInValidation}
        initialValues={{
          'email': '',
          'password': ''
        }}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            setSubmitting (true)
      
            const { data } = await cutileiApi.post ('/auth/companies', values)
            
            setErrorMessage (null)
            AuthService.signIn (data)
            navigate ('/company', { replace: true })
          } catch (error) {
            setErrorMessage (getApiErrorMessage (error))
          } finally {
            setSubmitting (false)
          }
        }}
      >
        {function SignInForm ({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        }) {
          return (
            <Form onSubmit={handleSubmit}>
              <Image src={CutileiLogo} alt='Cutilei para empresas'/>
              <Title>Entrar</Title>
              <Input
                type='email'
                placeholder='E-mail'
                value={values.email}
                onChange={handleChange ('email')}
                onBlur={handleBlur ('email')}
              />
              {touched.email && errors.email && (
                <WarningText>
                  {errors.email}
                </WarningText>
              )}
              <PasswordInput
                placeholder='Senha'
                value={values.password}
                onChange={handleChange ('password')}
                onBlur={handleBlur ('password')}
                containerStyle={{marginTop: 10}}
              />
              {touched.password && errors.password && (
                <WarningText>
                  {errors.password}
                </WarningText>
              )}
              <LinkText to='/forgot-password' state={{ userType: 'company' }}>
                Esqueceu sua senha?
              </LinkText>
              {errorMessage && (
                <ErrorContainer>
                  <p>{errorMessage}</p>
                </ErrorContainer>
              )}
              <ButtonContainer>
                <Button type='submit' disabled={isSubmitting}>
                  {isSubmitting ? <ButtonLoading/> : 'Entrar'}
                </Button>
              </ButtonContainer>
              <Label>Ainda não cadastrou sua empresa?</Label>
              <LinkButton to='/company/signup'>
                Cadastrar-se
              </LinkButton>
            </Form>
          )
        }}
      </Formik>
    </Container>
  )
}
